/**
 * Rotta protetta.
 *
 * Attende la fine del ripristino della sessione prima di decidere: senza,
 * un reload della pagina rimanderebbe al login anche con una sessione valida,
 * perché il refresh silenzioso non è ancora concluso.
 */

import { Navigate, useLocation } from 'react-router-dom';
import type { ReactNode } from 'react';
import { useAuth } from '@/features/auth/auth-context';
import { Spinner } from '@/ui';

export function ProtectedRoute({ children }: { children: ReactNode }) {
  const { isAuthenticated, isInitializing } = useAuth();
  const location = useLocation();

  if (isInitializing) {
    return <Spinner label="Ripristino della sessione…" />;
  }

  if (!isAuthenticated) {
    // `from` permette di tornare alla pagina richiesta dopo il login.
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  return <>{children}</>;
}
